import { render, staticRenderFns } from "./FreeShippingBar.vue?vue&type=template&id=f196887e&scoped=true&"
import script from "./FreeShippingBar.vue?vue&type=script&lang=js&"
export * from "./FreeShippingBar.vue?vue&type=script&lang=js&"
import style0 from "./FreeShippingBar.vue?vue&type=style&index=0&id=f196887e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f196887e",
  null
  
)

export default component.exports